export const ORDER_PAGE_UUID = 'c594ffb9-709d-444d-9d69-be8b7ddc2e36'
